import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import propertyReducer from './slices/propertySlice';
import agentReducer from './slices/agentSlice';
import blogReducer from './slices/blogSlice';
import adminReducer from './slices/adminSlice';
import contactReducer from './slices/contactSlice';
import testimonialReducer from './slices/testimonialSlice'; // ✅ ADD THIS

const store = configureStore({
  reducer: {
    auth: authReducer,
    properties: propertyReducer,
    agents: agentReducer,
    blogs: blogReducer,
    admin: adminReducer,
    contact: contactReducer,
    testimonials: testimonialReducer // ✅ ADD THIS
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST']
      }
    })
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
